exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner[data-v-01b39831] {\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n.spinner--1[data-v-01b39831] {\n  border-top: 2px solid #c7c7c7;\n  animation: spinner1-01b39831 600ms linear infinite;\n}\n@keyframes spinner1-01b39831 {\nto {\n    transform: rotate(360deg);\n}\n}", ""]);

// exports
